module.exports = __webpack_public_path__ + "img/personStock.7d534719.svg";